export default "__VITE_ASSET__BkSdiyIV__"